module.exports = __webpack_public_path__ + "static/our_approach_2-d226e77f346a2a313b5c2de25c9fe868.jpg";